import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-program-summary-report',
  imports: [ReportRunnerComponent],
  templateUrl: './program-summary-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramSummaryReportComponent {}
